const TAG_PILL_CLASSES =
  'inline-flex items-center px-2 py-1 text-xs font-medium bg-primary-100 text-primary-800 rounded-full';

export interface MediaDetailTagsEditorProps {
  tags: string[];
  isEditing: boolean;
  editTags: string[];
  newTag: string;
  isLoading: boolean;
  onNewTagChange: (value: string) => void;
  onAddTag: () => void;
  onRemoveTag: (tag: string) => void;
  onStartEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
}

export const MediaDetailTagsEditor = ({
  tags,
  isEditing,
  editTags,
  newTag,
  isLoading,
  onNewTagChange,
  onAddTag,
  onRemoveTag,
  onStartEdit,
  onSave,
  onCancel,
}: MediaDetailTagsEditorProps) => (
  <div>
    <div className="flex items-center justify-between mb-2">
      <span className="text-sm font-medium text-gray-700">Tags</span>
      {!isEditing && (
        <button onClick={onStartEdit} className="text-xs text-primary-600 hover:text-primary-700">
          Edit
        </button>
      )}
    </div>
    {isEditing ? (
      <div className="space-y-3">
        {/* Add new tag */}
        <div className="flex space-x-2">
          <input
            type="text"
            value={newTag}
            onChange={(e) => onNewTagChange(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && onAddTag()}
            placeholder="Add tag..."
            className="flex-1 px-2 py-1 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-info-500 focus:border-info-500"
          />
          <button
            onClick={onAddTag}
            disabled={!newTag.trim() || editTags.includes(newTag.trim())}
            className="px-2 py-1 text-xs font-medium text-white bg-primary-600 rounded hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Add
          </button>
        </div>

        {/* Current tags */}
        <div className="flex flex-wrap gap-1">
          {editTags.map((tag) => (
            <span key={tag} className={TAG_PILL_CLASSES}>
              {tag}
              <button
                onClick={() => onRemoveTag(tag)}
                className="ml-1 text-primary-600 hover:text-primary-800"
              >
                ×
              </button>
            </span>
          ))}
        </div>

        <div className="flex space-x-2">
          <button
            onClick={onSave}
            disabled={isLoading}
            className="px-3 py-1 text-xs font-medium text-white bg-primary-600 rounded hover:bg-primary-700 disabled:opacity-50"
          >
            Save
          </button>
          <button
            onClick={onCancel}
            disabled={isLoading}
            className="px-3 py-1 text-xs font-medium text-gray-700 bg-gray-100 rounded hover:bg-gray-200 disabled:opacity-50"
          >
            Cancel
          </button>
        </div>
      </div>
    ) : (
      <div className="flex flex-wrap gap-1">
        {tags.length > 0 ? (
          tags.map((tag) => (
            <span key={tag} className={TAG_PILL_CLASSES}>
              {tag}
            </span>
          ))
        ) : (
          <span className="text-sm text-gray-500">No tags</span>
        )}
      </div>
    )}
  </div>
);
